///* genera movimiento de inventario

import { erpApi } from '@/shared/axios/erp-api';
import { getUrlParamsFetch, handleAxiosError, toApiError, urlBackend } from "@/shared";
import { useUiStore } from "@/store/ui";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { IDataTrasladoInventario, ITrasladoInventario, ITrasladoInventarioParams } from '@/shared/interfaces';

const { get, post, put } = erpApi();

///* obtener traslado de inventario por id

export const useFetchTransferenciaInventarioById = (id: string, enabled = false) => {
  return useQuery({
    queryKey: ['traslado-inventario', id],
    queryFn: async () => {
      return await getTransferenciaInventarioById(id);
    },
    enabled: enabled
  });
};

export const getTransferenciaInventarioById = async (id: string) => {
  const resp = await get<IDataTrasladoInventario>(`${urlBackend}api/v1/traslado-inventario/${id}`, true);
  return resp.data;
};

///* obtener todos los traslados de inventario

export const useFetchTransferenciaInventariable = (params?: ITrasladoInventarioParams) => {
  return useQuery({
    queryKey: ['traslado-inventario', ...Object.values(params || {})],
    queryFn: async () => {
      return await getTransferenciaProducto(params);
    },
  });
};


export const getTransferenciaProducto = async (params?: ITrasladoInventarioParams) => {
  const queryParams = getUrlParamsFetch(params || {});

  const resp = await get<ITrasladoInventario>(`${urlBackend}api/v1/traslado-inventario/?${queryParams}`, true);
  return resp;
};


///* crear un traslado de inventario

export const useFetchCreateTransferenciaInventario = () => {
  const queryClient = useQueryClient();

  const setAlert = useUiStore.getState().setAlert;
  return useMutation({
    mutationFn: postTransferenciaProducto,
    onSuccess: async data => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ['traslado-inventario'],
        }),
        queryClient.invalidateQueries({
          queryKey: ['notificacion-inventario'],
        }),
      ]);

      setAlert(true, data.message, data.status);
    },
    onError: error => {

      const cleanError = toApiError(error);
      console.log(cleanError);
      handleAxiosError(error)
    }
  });
};

export const postTransferenciaProducto = async (data: ITrasladoInventarioParams) => {
  const resp = await post<IDataTrasladoInventario>(`${urlBackend}api/v1/traslado-inventario/`, data, true);
  return resp;
};

///* actualizar traslado de inventario

export const useFetchPuTrasladoInventario = () => {
  const queryClient = useQueryClient();

  const setAlert = useUiStore.getState().setAlert;
  return useMutation({
    mutationFn: putTrasladoInventario,
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey: ['traslado-inventario'] });
      setAlert(true, data.message, data.status);
    },
    onError: error => {

      const cleanError = toApiError(error);
      console.log(cleanError);
      handleAxiosError(error)
    }
  });
};

export const putTrasladoInventario = async ({ id, data }: { id: string, data: ITrasladoInventarioParams }) => {
  const resp = await put<IDataTrasladoInventario>(`${urlBackend}api/v1/traslado-inventario/${id}/`, data, true);
  return resp;
};
